// removed by extract-text-webpack-plugin
module.exports = {"Main":"Blog__Main__5auvq","Blog":"Blog__Blog__dM0AE","Title":"Blog__Title__1H9Kz"};


//////////////////
// WEBPACK FOOTER
// ./client/src/containers/Blog/Blog.css
// module id = 427
// module chunks = 0